import axios from "./axiosInstance";
import {
  GuardianDetailsApiResponse,
  GuardianApiResponse,
  LinkedStudentsApiResponse,
  GuardianCreatePayload,
  GuardianUpdatePayload,
  GuardianSearchParams,
} from "../types/guardianTypes";
import { ApiResponse } from "types/apiTypes";

/**
 * Fetch all guardians with optional pagination and search
 */
export const getGuardians = async (params?: { page?: number; limit?: number}): Promise<GuardianApiResponse> => {
  const response = await axios.get<GuardianApiResponse>("/guardian", { params });
  return response.data;
};

/**
 * Fetch a specific guardian by ID
 */
export const getGuardianById = async (guardianId: string): Promise<GuardianDetailsApiResponse> => {
  const response = await axios.get<GuardianDetailsApiResponse>(`/guardian/${guardianId}`);
  return response.data;
};

/**
 * Create a new guardian
 */
export const createGuardian = async (payload: GuardianCreatePayload): Promise<GuardianApiResponse> => {
  const response = await axios.post<GuardianApiResponse>("/guardian", payload);
  return response.data;
};

/**
 * Update an existing guardian
 */
export const updateGuardian = async (guardianId: string, payload: GuardianUpdatePayload): Promise<GuardianApiResponse> => {
  const response = await axios.put<GuardianApiResponse>(`/guardian/${guardianId}`, payload);
  return response.data;
};

/**
 * Soft delete a guardian
 */
export const deleteGuardian = async (guardianId: string): Promise<GuardianApiResponse> => {
  const response = await axios.delete<GuardianApiResponse>(`/guardian/${guardianId}`);
  return response.data;
};

/**
 * Fetch linked students for a guardian
 */
export const getLinkedStudents = async (guardianId: string): Promise<LinkedStudentsApiResponse> => {
  const response = await axios.get<LinkedStudentsApiResponse>(`/guardian/${guardianId}/students`);
  return response.data;
};

/**
 * Fetch Guardians Cross tenant
 */

export const searchGuardians = async (params: GuardianSearchParams): Promise<GuardianApiResponse> => {
  const response = await axios.get("/guardian/search", {
    params,
  });
  return response.data; 
};

export const getGuardianByStudentId = async ($id: string) => {
    const response = await axios.get<ApiResponse<any>> ("/guardian/student/" + $id);
    return response?.data;
};
